import { Color } from '../../../../utils/theme/types/color'

export const useStyles = (color: Color) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    width: '100%',
  },
  filter: {
    width: '200px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '20px',
    position: 'relative',
  },
  title: {
    fontSize: '20px',
    fontWeight: '600',
    color: color.color13,
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    '&.flex-j-e': {
      justifyContent: 'end',
    },
  },
  table: {
    flex: 0.8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingRight: '50px',
    paddingTop: '50px',
    width: 'inherit',
  },
  userDetail: {
    flex: 0.2,
  },
  section: {
    marginBottom: '32px',
  },
  clean: {
    fontSize: '2.4rem',
    color: color.color4,
    padding: '6px',
    '& .MuiSvgIcon-root': {
      fontSize: '1em',
    },
  },
  menuIcons: {
    marginLeft: '5px',
    fontSize: '18px',
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
    },
  },

  hide: {
    visibility: 'hidden',
  },
  text: {
    color: color.color13,
    fontSize: '16px',
    fontWeight: '500',
  },
  simpleModal: {
    width: '430px',
    '& .container.container': {
      margin: '0',
      marginTop: '5px',
      width: '100%',
      padding: '0',
    },
    '& .title.title': {
      width: '100%',
      paddingBottom: '10px',
      color: color.color13,
      // textAlign: 'start',
      paddingLeft: '30px',
    },
  },
  load: {
    '& .MuiSvgIcon-root': {
      background: color.color12,
      color: 'white',
      borderRadius: '5px',
      width: '30px',
      height: '30px',
    },
  },
})
